import React, { useState, useRef, useEffect, useContext } from "react";
import "../styles/LoginPage.css";
import ss from "../assets/images/shersoftnavLogo.png";
import ma from "../assets/images/masonslogo.png"
import pot from "../assets/images/masonspot-removebg-preview.png"
import logo from "../assets/images/masonsloginlogo-removebg-preview.png"


import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function LoginPage() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({
    userName: "",
    password: "",
  });

  const userNameRef = useRef(null);
  const passwordRef = useRef(null);
  const loginBtnRef = useRef(null);

  useEffect(() => {
    userNameRef.current.focus();
  }, []);

  const handleKeyDown = (event, nextInputRef) => {
    if (event.key === "Enter" || event.key === "Return") {
      nextInputRef.current.focus();
    }
  };

  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/userLogin`);
      const data = response.data;

      const user = data.find(user => user.userName === loginData.userName && user.password === loginData.password);

      if (user) {
        sessionStorage.setItem("agentCode", user.agentCode);
        sessionStorage.setItem("CustomerName",user.customer);
        sessionStorage.setItem("Uaccno",user.password);
        login(user.agentCode,user.userType); // Pass the agentCode to the login function
        navigate('/home');
      } else {
        setError('Invalid username or password');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred while logging in');
    }
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', handlePopstate);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const handlePopstate = () => {
    window.history.pushState(null, null, window.location.pathname);
  };

  return (
    <div className="LoginRoot">
      {/* <div className="loginimg w-[90vw] h-[220px] absolute left-auto right-auto top-[4vh] flex flex-col gap-2 items-center justify-center">
      <img src={pot} className="w-[150px] h-[150px]" />
      <label htmlFor=""></label>

      </div> */}
      <img src={pot} className="loginimg w-[130px] h-[130px] absolute left-auto right-auto top-[4vh]" />

      <img src={logo} alt="" className="loginimg w-[130px] h-[130px] absolute left-auto right-auto bottom-[4vh] "/>

      <div className="loginForm">
        <div className="loginHead">
          <img src={ma} alt="" className="h-6 w-6 rounded-lg"/>
          <label htmlFor=""> Login In To PROMISE</label>
        </div>
        <div className="loginBody">
          <div className="loginBodyRows">
            <label htmlFor="">User Name</label>
            <input
              type="text"
              ref={userNameRef}
              onKeyDown={(e) => handleKeyDown(e, passwordRef)}
              onChange={(e) => setLoginData({ ...loginData, userName: e.target.value })}
            />
          </div>
          <div className="loginBodyRows">
            <label htmlFor="">Password</label>
            <input
              type="password"
              ref={passwordRef}
              onKeyDown={(e) => handleKeyDown(e, loginBtnRef)}
              onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
            />
          </div>
          <div className="loginBodyRowsButton" style={{ display: "flex", justifyContent: "center" }}>
            <button className="loginButton" ref={loginBtnRef} onClick={handleLogin} style={{ width: '30%' }}>
              Log In
            </button>
          </div>
          {error && <div className="errorMessage">{error}</div>}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
